import './styles/theme.css';
import './styles/site.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import HomePage from './components/HomePage';
import GalleryPage from './components/GalleryPage';
import AlbumPage from './components/AlbumPage';
import AboutPage from './components/AboutPage';
import LawsDocumentPage from './components/LawsDocumentPage';
import ArticlePage from './components/ArticlePage';
import NewsListPage from './components/NewsListPage';
import ProjectsListPage from './components/ProjectsListPage';
import SbhrpPage from './components/SbhrpPage';
import SbhrpLabMembersPage from './components/SbhrpLabMembersPage';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about/:tab" element={<AboutPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/laws/document/:contentId" element={<LawsDocumentPage />} />
        <Route path="/news/list/:type" element={<NewsListPage />} />
        <Route path="/news/:id" element={<ArticlePage kind="news" />} />
        <Route path="/projects" element={<ProjectsListPage />} />
        <Route path="/projects/:id" element={<ArticlePage kind="projects" />} />
        <Route path="/sbhrp" element={<SbhrpPage />} />
        <Route path="/sbhrp/lab-members" element={<SbhrpLabMembersPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/:albumId" element={<AlbumPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
